import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=2329f6a5&scoped=true&"
import script from "./SocialButton.vue?vue&type=script&lang=js&"
export * from "./SocialButton.vue?vue&type=script&lang=js&"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=2329f6a5&prod&lang=scss&scoped=true&"
import style1 from "./SocialButton.vue?vue&type=style&index=1&id=2329f6a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329f6a5",
  null
  
)

export default component.exports